export default "__VITE_ASSET__BEaZvZhr__"